module.exports = __webpack_public_path__ + "static/media/mariadb.66010b9c.svg";